import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LogoKaGk from "../../assets/icons/logo-ka-gk.svg";
import LogoKaFk from "../../assets/icons/logo-ka-fk.svg";
import LogoKaMk from "../../assets/icons/logo-ka-mk.svg";
import LogoKa from "../../assets/icons/logo-ka.svg";
import LogoKaPet from "../../assets/icons/logo-ka-pet.svg";
import LogoKaCometas from "../../assets/icons/logo-ka-cometas.svg";
import CustomButton from "../CustomButton";
import { PiUsersThree } from "react-icons/pi";
import { FaRegCreditCard } from "react-icons/fa6";
import { TbMedicalCross } from "react-icons/tb";
import { IoSchoolOutline } from "react-icons/io5";
import { MdOutlineLocalPharmacy } from "react-icons/md";
import { TbBeach } from "react-icons/tb";
import "./JoinUsCall.css";

export default function JoinUsCall(props) {
  const [currenKaIcon, setCurrenKaIcon] = useState(null);

  useEffect(() => {
    function changeTitleIcon() {
      if (props.iconColor === "#093015") {
        setCurrenKaIcon(
          <img
            src={LogoKaGk}
            alt="ícone assistencial"
            className="join-us-call-icon-ka"
          />
        );
      }
      if (props.iconColor === "#304E32") {
        setCurrenKaIcon(
          <img
            src={LogoKaFk}
            alt="ícone assistencial"
            className="join-us-call-icon-ka"
          />
        );
      }
      if (props.iconColor === "#C8A4AD") {
        setCurrenKaIcon(
          <img
            src={LogoKaMk}
            alt="ícone assistencial"
            className="join-us-call-icon-ka"
          />
        );
      }
      if (props.iconColor === "#E97444") {
        setCurrenKaIcon(
          <img
            src={LogoKa}
            alt="ícone assistencial"
            className="join-us-call-icon-ka"
          />
        );
      }
      if (props.iconColor === "#E36E2D") {
        setCurrenKaIcon(
          <img
            src={LogoKaPet}
            alt="ícone assistencial"
            className="join-us-call-icon-ka"
          />
        );
      }
      if (props.iconColor === "#EEB53A") {
        setCurrenKaIcon(
          <img
            src={LogoKaCometas}
            alt="ícone assistencial"
            className="join-us-call-icon-ka"
          />
        );
      }
    }
    changeTitleIcon();
  }, [props.iconColor]);

  return (
    <div>
      <Container>
        <Row>
          <Col className="join-us-call-first-col">
            <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
              <PiUsersThree
                style={{ color: props.iconColor }}
                className="join-us-call-icon"
              />
              TRABALHE CONOSCO
            </h2>
          </Col>
        </Row>
      </Container>
      <Container fluid className="join-us-call-fluid-container">
        <div
          style={{ background: props.fadeBG }}
          className="join-us-call-img-overlay"
        />
      </Container>
      <Container fluid>
        <Container className="join-us-call-container">
          <Row>
            <Col>
              <div className="join-us-call-card">
                <div
                  className="join-us-call-circle"
                  style={{ background: props.circleBG }}
                >
                  <FaRegCreditCard
                    style={{ color: props.iconColor }}
                    className="join-us-call-circle-icon"
                  />
                </div>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Cartão Multibenefícios
                </p>
              </div>
            </Col>
            <Col>
              <div className="join-us-call-card">
                <div
                  className="join-us-call-circle"
                  style={{ background: props.circleBG }}
                >
                  {currenKaIcon}
                </div>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Plano Grupo Krause
                </p>
              </div>
            </Col>
            <Col>
              <div className="join-us-call-card">
                <div
                  className="join-us-call-circle"
                  style={{ background: props.circleBG }}
                >
                  <TbMedicalCross
                    style={{ color: props.iconColor }}
                    className="join-us-call-circle-icon"
                  />
                </div>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Plano de Saúde
                </p>
              </div>
            </Col>
            <Col>
              <div className="join-us-call-card">
                <div
                  className="join-us-call-circle"
                  style={{ background: props.circleBG }}
                >
                  <IoSchoolOutline
                    style={{ color: props.iconColor }}
                    className="join-us-call-circle-icon"
                  />
                </div>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Auxílio Educação
                </p>
              </div>
            </Col>
            <Col>
              <div className="join-us-call-card">
                <div
                  className="join-us-call-circle"
                  style={{ background: props.circleBG }}
                >
                  <MdOutlineLocalPharmacy
                    style={{ color: props.iconColor }}
                    className="join-us-call-circle-icon"
                  />
                </div>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Convênio Farmácia
                </p>
              </div>
            </Col>
            <Col>
              <div className="join-us-call-card">
                <div
                  className="join-us-call-circle"
                  style={{ background: props.circleBG }}
                >
                  <TbBeach
                    style={{ color: props.iconColor }}
                    className="join-us-call-circle-icon"
                  />
                </div>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Day off Aniversário
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="join-us-call-second-col">
              <CustomButton
                className="primary-btn"
                variant="primary"
                href="/trabalhe-conosco/"
                rel="noopener noreferrer"
                icon=""
                content="VEJA AS VAGAS"
                backgroundColor={props.btnColor}
                fontFamily="Unageo-Bold"
                fontColor={props.white}
                fontSize={20}
                width={240}
                borderColor={props.btnColor}
                disabled={false}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
